module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_Bankoslowka_KARTA_KREDYTOWA.2e1f6264.mp3";